import {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";

/**
 * Component for selecting a language.
 * Supported languages are loaded at runtime from /locales/languages.json,
 * allowing end-users to configure available languages without rebuilding.
 */
interface LocaleSelectorProps {
    className?: string
}

export const LocaleSelector = ({className}: LocaleSelectorProps) =>
{
    const {i18n} = useTranslation();

    const [supportedLanguages, setSupportedLanguages] = useState<string[]>(["en"]);

    useEffect(() => {
        fetch('/locales/languages.json')
            .then(res => res.json())
            .then(data => setSupportedLanguages(data))
            .catch(() => setSupportedLanguages(["en"]));
    }, []);

    return (
        <Form.Select aria-label="Select Language" className={className} size="sm"
            value={i18n.resolvedLanguage ?? "en"}
            onChange={(e) => i18n.changeLanguage(e.target.value)}
        >
            {supportedLanguages.map(name => (
                <option value={name} key={name}>
                    {name}
                </option>
            ))}
        </Form.Select>
    );
};
